import React from 'react';
import { Layout, LegacyCard, SkeletonPage, TextContainer, SkeletonBodyText, SkeletonDisplayText, Tabs, InlineStack, Button, Divider, FormLayout } from '@shopify/polaris';

export function SkeletonPageSettings(props) {
    const tabs = [
        {
            id: 'general',
            content: 'General',
            accessibilityLabel: 'General',
            panelID: 'general-content',
        },
        {
            id: 'billing',
            content: 'Billing',
            panelID: 'billing-content',
        },
        {
            id: 'partners',
            content: 'Partners',
            panelID: 'partners-content',
        }
    ];

    return (
        <SkeletonPage title="Settings">
            <LegacyCard>
                <Tabs tabs={tabs} selected={props.tabIndex} onSelect={(index) => { }} fitted>
                </Tabs>
            </LegacyCard>
            <Layout>
                <Layout.Section>
                    <div className="revert-defaults-container">
                        <InlineStack align="end">
                            <Button variant="secondary" tone="base">Revert defaults</Button>
                        </InlineStack>
                    </div>
                </Layout.Section>
                <Layout.AnnotatedSection title="General">
                    <LegacyCard sectioned>
                        <FormLayout>
                            <div className="setting-block-skeleton-80">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </TextContainer>
                            </div>
                            <Divider />
                            <div className="setting-block-skeleton-80">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </TextContainer>
                            </div>
                            <Divider />
                            <div className="setting-block-skeleton-100">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={3} />
                                </TextContainer>
                            </div>
                        </FormLayout>
                    </LegacyCard>
                </Layout.AnnotatedSection>
                <Layout.AnnotatedSection title="Launcher">
                    <LegacyCard sectioned>
                        <FormLayout>
                            <div className="setting-block-skeleton-72">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </TextContainer>
                            </div>
                            <div className="setting-block-skeleton-52">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={1} />
                                </TextContainer>
                            </div>
                            <Divider />
                            <div className="setting-block-skeleton-56">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={1} />
                                </TextContainer>
                            </div>
                            <div className="setting-block-skeleton-80">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </TextContainer>
                            </div>
                            <Divider />
                            <div className="setting-block-skeleton-72">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </TextContainer>
                            </div>
                            <Divider />
                            <div className="setting-block-skeleton-200">
                                <TextContainer>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={8} />
                                </TextContainer>
                            </div>
                        </FormLayout>
                    </LegacyCard>
                </Layout.AnnotatedSection>
            </Layout>
        </SkeletonPage>
    );
}